import React, { useEffect, useState } from 'react';
import { BackstageExperience } from '../components/fans/BackstageExperience';
import { backstageStorageKey, backstageUpdatedEvent, getBackstageContentFromUrl, getPublishedBackstageContent, type BackstageContent } from '../data/backstage';
export function Backstage() {
  const sharedPreviewContent = getBackstageContentFromUrl();
  const captureSourceId = new URLSearchParams(window.location.search).get('source')?.trim() || undefined;
  const [content, setContent] = useState<BackstageContent>(() => sharedPreviewContent ?? getPublishedBackstageContent());
  const isSharedPreview = Boolean(sharedPreviewContent);
  useEffect(() => {
    if (isSharedPreview) return undefined;
    const refreshPublishedContent = () => setContent(getPublishedBackstageContent());
    const syncCurrentWindow = (event: Event) => {
      const customEvent = event as CustomEvent<BackstageContent>;
      setContent(customEvent.detail ?? getPublishedBackstageContent());
    };
    const syncOtherWindow = (event: StorageEvent) => {
      if (event.key === backstageStorageKey) refreshPublishedContent();
    };
    window.addEventListener(backstageUpdatedEvent, syncCurrentWindow);
    window.addEventListener('storage', syncOtherWindow);
    window.addEventListener('focus', refreshPublishedContent);
    return () => {
      window.removeEventListener(backstageUpdatedEvent, syncCurrentWindow);
      window.removeEventListener('storage', syncOtherWindow);
      window.removeEventListener('focus', refreshPublishedContent);
    };
  }, [isSharedPreview]);
  return <BackstageExperience content={content} captureSourceId={captureSourceId} data-id="element-1470" data-mp="29pua0an8jj6" />;
}